import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'

export function NotificationPanelSkeleton() {
  return (
    <Box
      data-testid="provider-notification-panel-skeleton"
      aria-busy="true"
      aria-label="Loading notifications"
      sx={{ px: '16px', py: '12px', display: 'flex', flexDirection: 'column', gap: '8px' }}
    >
      {Array.from({ length: 3 }, (_, i) => (
        <Skeleton key={i} variant="rounded" height={76} sx={{ borderRadius: '4px' }} />
      ))}
    </Box>
  )
}
